// pickOppAvatar — escolhe um avatar deterministico pro oponente
// quando o snapshot dele NAO carrega avatar explicit. Hash do id
// no pool de 16 personagens, excluindo o meu pra evitar dois
// rostos iguais na mesa.

const ALL_CHARS: string[] = Array.from({ length: 16 }, (_, i) => `character${i + 1}`);

function hashStr(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return h;
}

export function pickOppAvatar(oppId: string, myAvatar: string): string {
  const pool = ALL_CHARS.filter((c) => c !== myAvatar);
  const idx = hashStr(oppId) % pool.length;
  return pool[idx];
}

// resolveAvatar — usa avatar do snapshot se vier, senao calcula
// deterministic. opponentSide = true filtra fora o meu avatar.
export function resolveAvatar(
  snapAvatar: string | undefined,
  fallbackId: string,
  myAvatar: string,
  opponentSide: boolean,
): string {
  if (snapAvatar) return snapAvatar;
  if (opponentSide) return pickOppAvatar(fallbackId, myAvatar);
  return myAvatar;
}
